export default "__VITE_ASSET__Dxj8Uvm1__"